import { EmojiEvents as EmojiEventsIcon } from '@mui/icons-material';
import { alpha, Box, Button } from '@mui/material';

import { useT } from '@/hooks';

import { PALETTE_KEYS } from '@/constants';

interface LeaderboardFloatingButtonProps {
  onClick: () => void;
}

export const LeaderboardFloatingButton = ({ onClick }: LeaderboardFloatingButtonProps) => {
  const { t } = useT();

  return (
    <Box
      sx={{
        display: { xs: 'block', lg: 'none' },
        position: 'fixed',
        bottom: 80,
        right: 24,
        zIndex: 10,
      }}
    >
      <Button
        variant="outlined"
        onClick={onClick}
        startIcon={<EmojiEventsIcon sx={{ color: PALETTE_KEYS.PRIMARY_MAIN }} />}
        sx={{
          borderRadius: '24px',
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.9375rem',
          px: { xs: 2, sm: 3 },
          py: 1,
          bgcolor: (theme) =>
            theme.palette.mode === 'dark'
              ? theme.palette.background.paper
              : PALETTE_KEYS.COMMON_WHITE,
          color: (theme) =>
            theme.palette.mode === 'dark' ? theme.palette.common.white : PALETTE_KEYS.PRIMARY_MAIN,
          border: '2px solid',
          borderColor: PALETTE_KEYS.PRIMARY_MAIN,
          boxShadow: (theme) => `0px 4px 12px ${alpha(theme.palette.primary.main, 0.2)}`,
          '&:hover': {
            bgcolor: (theme) =>
              theme.palette.mode === 'dark'
                ? alpha(theme.palette.background.paper, 0.8)
                : PALETTE_KEYS.GREY_50,
            border: '2px solid',
            borderColor: PALETTE_KEYS.PRIMARY_MAIN,
          },
        }}
      >
        {t('leaderboard.biggestWins')}
      </Button>
    </Box>
  );
};
